import { splitPageSelectors } from '@provider/print';
import { printAST } from '@utils/ast';
import { Caption } from '../atoms/Caption.js';
import { textComponentChildPrinters } from '../printer.to-jsx.js';
import { tokens, wrapper, heading, content, caption } from './page.content.style.js';
import { printPrintableAnchorNode } from './printer.anchor.js';
import { printPrintableGlossaryWord } from './printer.glossary-word.js';
import { jsxs, jsx } from 'react/jsx-runtime';

function ContentPrintPage(props) {
  return /*#__PURE__*/jsxs("div", {
    className: wrapper,
    style: tokens.__override({
      columnCount: props.columnCount
    }),
    children: [props.node.meta.caption.title?.value && /*#__PURE__*/jsx("h3", {
      className: heading,
      children: /*#__PURE__*/jsx("span", {
        dangerouslySetInnerHTML: {
          __html: props.node.meta.caption?.title?.value
        }
      })
    }), /*#__PURE__*/jsxs("div", {
      className: content,
      children: [/*#__PURE__*/jsx(Caption, {
        className: caption,
        scrambled: false,
        caption: props.node.meta.caption,
        includeContext: "outside-context",
        omitTitle: true,
        omitDescription: true
      }), /*#__PURE__*/jsx("div", {
        className: splitPageSelectors.includeInLineCount.className,
        children: printAST(props.node.children, {
          ...textComponentChildPrinters,
          "text-component.glossary-word": printPrintableGlossaryWord,
          "text-component.anchor": printPrintableAnchorNode
        })
      })]
    })]
  });
}

export { ContentPrintPage };
//# sourceMappingURL=page.content.js.map
